export const getScoredResults = ({ results }: { results: ScoredResults[] }) => {
  const filteredResults = results.filter(result => {
    if (result._meta.score > 0.2) return result;
    return null;
  });
  return filteredResults;
};

type ScoredResults = {
  [key: string]: {
    raw: string;
    score: number;
  };
};
